@if (reinsurances?.length > 0) {
  <sd-component-wrapper [themesConfig]="themesConfig">
    <sd-reinsurances sd-component-wrapper-component
      [parentsThemesConfig]="themesConfig"
      [reinsurances]="reinsurances"
      (clickedReinsurance)="onClickEvent($event)"
      [titleLevel]="titleLevel"
      [isBrand]="isBrand"
      [hasSubline]="hasSubline"
      [textConfig]="textConfig"
    />
  </sd-component-wrapper>
}
